import { render, staticRenderFns } from "./UserGet.vue?vue&type=template&id=5cbeef65&scoped=true&"
import script from "./UserGet.vue?vue&type=script&lang=js&"
export * from "./UserGet.vue?vue&type=script&lang=js&"
import style0 from "./UserGet.vue?vue&type=style&index=0&id=5cbeef65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbeef65",
  null
  
)

export default component.exports